// extracted by mini-css-extract-plugin
export default {"spinnerIcon":"spinnerIcon--PmCNh3i0","loadingCircle":"loadingCircle--K9pY0MO8"};